import { combineReducers } from 'redux'

import user from './user/reducer'
import transcriptions from './transcriptions/reducer'

export default combineReducers({
  user,
  transcriptions
})



// WEBPACK FOOTER //
// ./src/redux/reducer.js